import { type FC } from "react";
import { Typography } from "@/components/essentials/typography";
import { Box } from "@/components/essentials/box";
import Link from "next/link";
import { toysubExchangeChanneltalkUrl } from "@/configs/externalUrls";
import { disableNotificationTestId } from "./const";

export const DisableNotification: FC = () => {
  return (
    <Box w="100%" background="mono.light.12" borderRadius="16px" p={4} mb={4} data-testid={disableNotificationTestId}>
      <Typography variant="display5" color="theme.yellow.70" mb={3}>
        現在、お届け先情報の変更は行えません
      </Typography>
      <Typography variant="text4">
        発送準備中のため、お届け先住所の変更・新規追加は行えません。
        <br />
        緊急の場合は、
        <Typography
          as={Link}
          href={toysubExchangeChanneltalkUrl}
          size="sm"
          variant="text4"
          color="theme.green.main"
          textDecor="underline"
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </Typography>
        よりお問い合わせください。
      </Typography>
    </Box>
  );
};
